import { render, staticRenderFns } from "./remote-signaling.vue?vue&type=template&id=91fbca2c&scoped=true"
import script from "./remote-signaling.vue?vue&type=script&lang=js"
export * from "./remote-signaling.vue?vue&type=script&lang=js"
import style0 from "./remote-signaling.vue?vue&type=style&index=0&id=91fbca2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fbca2c",
  null
  
)

export default component.exports